<template>
  <div id="divContainer" v-on:click="exitmenu" class="page-effect">
    <!-- <TopMenu /> -->
    <section
      id="sectionId"
      class="d-flex"
      style="
        background-image: url('https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FBranding%2FEvent%20Background_2732x2048%20pixels.jpg?alt=media');
      "
    >
      <div class="container-fluid pl-80">
        <iframe style="height:100vh"  frameborder="0"  width="100%" :src="EmbededIframeCode"></iframe>
      </div>
    </section>
  </div>
</template>
<script>
import db from "../components/firebaseInit";
import jQuery from "jquery";
let $ = jQuery;
export default {
  components: {},
  data() {
    return {
      EmbededIframeCode: "",
    };
  },
  mounted() {
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    $("#btnAddUserView").click();
    $("#imgBanner").attr("src", obj.EventBranding[0].banner);
    $("#topmenu").show();
    //this.setGamificationSetting();

    var path = "https://" + this.$route.query.type;
    // this.EmbededIframeCode =  path.replace('"', "");
     console.log("EmbededIframeCode>>>>>>>","https://zoomapi.e2m.live/iframe.php?loadurl=" + path.replace('"', ""));
    this.EmbededIframeCode = "https://zoomapi.e2m.live/iframe.php?loadurl=" + path.replace('"', "");



  },
  methods: {
    setGamificationSetting: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname)
        .doc("EventInfo")
        .get()
        .then((doc) => {
          if (doc.exists) {
            var docs = doc.data();
            if (docs.Plugins != undefined) {
              if (docs.Plugins.Gamification != undefined) {
                   var firstName = obj.user[0].fname;
                   var lastName = obj.user[0].lname;
                   var email = obj.user[0].Email;
                this.EmbededIframeCode = docs.Plugins.Gamification.EmbededIframeCode + '?f='+firstName.trim()+'&l='+lastName.trim()+'&e='+email.trim();
              }
            }
          }
        })
        .catch((error) => {
          console.log("Error getting documents:", error);
          //alert(error);
        });
    },
    exitmenu: function () {
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
  },
};
</script>


<style scoped>
.full-page-frame {
  height: calc(100vh - 116px) !important;
  width: 100%;
}
.pl-80{
    padding-left: 80px;
}
</style>
